module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "team-reports-upsell-illustration.ca104749.png" + "?" + Date.now();